/**
 * se questa classe non è riportata sia sul contenitore della planimetria, sia nel confronto del metodo di gestione del grab,
 * grab e trascinamento dell'icona andranno in conflitto, se assente sul contenitore della planimetria, il grab non funzionerà totalmente.
 *  */
export const containerClass = "dropzone"